import { UNSAFE_createBrowserHistory } from 'react-router';

// The app's one browser history (PANEL-1549), handed to <AppRouter> in src/index.js. v5Compat: every
// push/replace notifies the listeners, as react-router 5's history did; without it only browser
// back/forward would, and AppRouter would never see the app's own navigations.
const history = UNSAFE_createBrowserHistory({ v5Compat: true });

export default history;
